import { FC, useContext, useEffect } from "react";
import { EnterpriseComplianceDashboardContext } from "../contexts/EcdContext";
import { DashboardTile } from "@app/shared/qes-standards";
import { EnterpriseComplianceFiltersContext } from "../contexts/EcdFiltersContext";
import { EcdTilesEnum } from "../interfaces";
import LineOfBusinessTable from "../components/LineOfBusinessTable";

const LineOfBusinessOverview: FC = () => {
    const filtersContext = useContext(EnterpriseComplianceFiltersContext);
    const dashboardContext = useContext(EnterpriseComplianceDashboardContext);

    useEffect(() => {
        dashboardContext.updateIsTileLoadingMap(EcdTilesEnum.LineOfBusinessOverview, true);
    }, []);

    useEffect(() => {
        if (dashboardContext.lineOfBusinessData?.length > 0) {
            dashboardContext.updateIsTileLoadingMap(EcdTilesEnum.LineOfBusinessOverview, false);
        }
    }, [dashboardContext.lineOfBusinessData]);

    useEffect(() => {
        if (!!filtersContext.apiReadyFilters) {
            dashboardContext.updateIsTileLoadingMap(EcdTilesEnum.LineOfBusinessOverview, true);
        }
    }, [filtersContext.apiReadyFilters]);

    return (
        <DashboardTile
            loading={filtersContext.isDashboardLoading || dashboardContext.isTileLoadingMap.get(EcdTilesEnum.LineOfBusinessOverview)}
            title="Line of Business Overview"
            widthClass="col-md-12 col-xl-6"
        >
          <LineOfBusinessTable tableData={ dashboardContext.lineOfBusinessData } />
        </DashboardTile>
    )
}

export default LineOfBusinessOverview;